import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as offerings from '../../offerings'

export const RESOURCE = {
  payload: {
    description:
      'A task within a phase of an offering that represents a distinct activity or assignment, such as "Research", "Design", or "Implementation".',
    dimension: offerings.RESOURCE.payload,
    level: 2,
    name: 'Task',
    partialId: PartialId.Standard.create('task'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
